module.exports = __webpack_public_path__ + "img/training-outdoor.7bc73e53.svg";